export const OPS_HEALTH_LOADING = 'OPS_HEALTH_LOADING';
export const SUCCESS_GET_OPS_HEALTH = 'SUCCESS_GET_OPS_HEALTH';
export const FAILED_GET_OPS_HEALTH = 'FAILED_GET_OPS_HEALTH';



// WEBPACK FOOTER //
// src/state/constants/opsHealthConstants.js